// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meebit: {
    4: "",
    1: "0x7bd29408f11d2bfc23c34f18275bbf23bb716bc7",
    56: "",
    97: "",
  },
  jetpack: {
    4: "0x3400DAf37D1Ed8abD85b86Ee6F0CFEdFF2220740",
    1: "",
    56:"",
    97: "",
  },
  multiCall: {
    1: '0xeefba1e63905ef1d7acba5a8513c70307c1ce441',
    4: '0x42ad527de7d4e9d9d011ac45b31d8551f8fe9821',
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
  },
};
